import { Button, Grid2 } from '@mui/material';
import { Field, FieldArray, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { AutoCompleteField } from '../../../../shared/components/formfields/AutoCompleteField';
import { Grid_Gap, Grid_Gap_LG, Input_Width, Input_Width_LG } from '../../../../shared/constants';
import { TextFormField } from '../../../../shared/components/formfields/TextFormField';
import { DateFormField } from '../../../../shared/components/formfields/DataFormField';
import CustomDivider from '../../../../shared/utils/CustomDivider';
import CustomSlider from './../../../../shared/components/formfields/CustomSlider'
import AddIcon from '@mui/icons-material/Add';
import MilestonesWrapper from '../../../../shared/components/admin/MilestonesWrapper';
import SprintWrapper from '../../../../shared/components/admin/SprintWrapper';
import { DropzoneUploadFormField } from '../../../../shared/components/formfields/DropzoneUploadFormField';


const MilestoneCourses = () => {
    const CourseCategory = [
        {
            id: 1,
            value: "category1",
            label: "category1"
        },
        {
            id: 2,
            value: "category2",
            label: "category2"
        },
    ]
    const initialValues = {
        image: null,
        course_category: '',
        location: '',
        name: '',
        shortDescription: '',
        description: '',
        learningOutcome: '',
        startDate: null,
        endDate: null,
        age: 0,
        price: '',
        milestones: [

        ],
    };

    //  {
    //             milestoneName: '',
    //             milestoneDescription: '',
    //             learningOutcome: '',
    //             prize: '',
    //             reductionPrize: '',
    //             subject: '',
    //             sprints: [
    //                 {
    //                     sprintName: '',
    //                     description: '',
    //                     learningOutcome: '',
    //                     prize: '',
    //                     reductionPrize: '',
    //                     numberOfSections: '',
    //                 },
    //             ],
    //         },
    const handleSubmit = (values, { setSubmitting, resetForm }) => {
   
    }
    return (
        <>
            <Formik initialValues={initialValues}
                validationSchema={Yup.object().shape({})}
                onSubmit={handleSubmit}
                enableReinitialize={true}
            >
                {({ values, resetForm }) => (
                    <Form>
                        <Grid2 container spacing={Grid_Gap_LG} >
                            <Grid2 children size={{ xs: 12 }}>
                                <Field
                                    name="image"
                                    label="Upload Course Image"
                                    component={DropzoneUploadFormField}
                                />


                            </Grid2>
                            <Grid2 children size={Input_Width_LG}>
                                <Field
                                    name="course_cateogry"
                                    component={AutoCompleteField}
                                    options={CourseCategory}
                                    label="Courses Category"
                                    isRequired={true}
                                />
                            </Grid2>
                            <Grid2 children size={Input_Width_LG}>
                                <Field
                                    name="location"
                                    component={AutoCompleteField}
                                    options={CourseCategory}
                                    label="Location"
                                    isRequired={true}
                                />
                            </Grid2>
                            <Grid2 children size={Input_Width_LG}>
                                <Field
                                    name="name"
                                    component={TextFormField}
                                    label="Course Name"
                                    isRequired={true}
                                />
                            </Grid2>
                            <Grid2 children size={Input_Width_LG}>
                                <Field
                                    name="des"
                                    component={TextFormField}
                                    label="Short Description"
                                    isRequired={true}
                                />
                            </Grid2>
                            <Grid2 children size={Input_Width_LG}>
                                <Field
                                    name="des"
                                    component={TextFormField}
                                    label="Description"
                                    isRequired={true}
                                />
                            </Grid2>
                            <Grid2 children size={Input_Width_LG}>
                                <Field
                                    name="learning_outcome"
                                    component={TextFormField}
                                    label="Learning Outcome"
                                    isRequired={true}
                                />
                            </Grid2>
                            <Grid2 children size={Input_Width_LG}>
                                <Field
                                    name="Start_Date"
                                    component={DateFormField}
                                    label="Start Date"
                                    isRequired={true}
                                />
                            </Grid2>
                            <Grid2 children size={Input_Width_LG}>
                                <Field
                                    name="Start_Date"
                                    component={DateFormField}
                                    label="End Date"
                                    isRequired={true}
                                />
                            </Grid2>

                            <Grid2 children size={Input_Width_LG}>
                                <Field
                                    name="age"
                                    component={CustomSlider}
                                    label="Set age limit"
                                    initialValue={0}
                                    finalValue={20}
                                />
                            </Grid2>
                            <Grid2 children size={Input_Width_LG}>
                                <Field
                                    name="price"
                                    component={TextFormField}
                                    label="Price"
                                    isRequired={true}
                                />
                            </Grid2>



                        </Grid2>
                        <CustomDivider />

                        <FieldArray name="milestones">
                            {({ push: pushMilestone, remove: removeMilestone }) => (
                                <>
                                    {values.milestones.map((milestone, mIndex) => (
                                        <>
                                            <MilestonesWrapper
                                                key={mIndex}
                                                headerText={`Milestone ${mIndex + 1}`}
                                                onDelete={() => removeMilestone(mIndex)}
                                            >
                                                <Grid2 container spacing={Grid_Gap_LG}>
                                                    <Grid2 children size={12}>
                                                        <Field
                                                            name={`milestones[${mIndex}].milestoneName`}
                                                            component={TextFormField}
                                                            label="Milestone Name"
                                                        />
                                                    </Grid2>
                                                    <Grid2 children size={12}>
                                                        <Field
                                                            name={`milestones[${mIndex}].milestoneDescription`}
                                                            component={TextFormField}
                                                            label="Milestone Description"
                                                            multiline
                                                            row={3}
                                                        />
                                                    </Grid2>
                                                    <Grid2 children size={12}>
                                                        <Field
                                                            name={`milestones[${mIndex}].learningOutcome`}
                                                            component={TextFormField}
                                                            label="Learning Outcome"
                                                            multiline
                                                            row={3}
                                                        />
                                                    </Grid2>
                                                    <Grid2 children size={12}>
                                                        <Field
                                                            name={`milestones[${mIndex}].prize`}
                                                            component={TextFormField}
                                                            label="Prize"
                                                        />
                                                    </Grid2>
                                                    <Grid2 children size={12}>
                                                        <Field
                                                            name={`milestones[${mIndex}].reductionPrize`}
                                                            component={TextFormField}
                                                            label="Reduction Prize"
                                                        />
                                                    </Grid2>
                                                    <Grid2 children size={12}>
                                                        <Field
                                                            name={`milestones[${mIndex}].subject`}
                                                            component={TextFormField}
                                                            label="Subject"
                                                        />
                                                    </Grid2>
                                                </Grid2>
                                                <CustomDivider />


                                                <FieldArray name={`milestones[${mIndex}].sprints`}>
                                                    {({ push: pushSprint, remove: removeSprint }) => (
                                                        <>


                                                            {milestone.sprints.map((sprint, sIndex) => (
                                                                <SprintWrapper
                                                                    key={sIndex}
                                                                    headerText={`Sprint ${sIndex + 1}`}
                                                                    onDelete={() => removeSprint(sIndex)}
                                                                >
                                                                    <Grid2 container spacing={Grid_Gap_LG}>
                                                                        <Grid2 children size={12}>
                                                                            <Field
                                                                                name={`milestones[${mIndex}].sprints[${sIndex}].sprintName`}
                                                                                component={TextFormField}
                                                                                label="Sprint Name"
                                                                            />
                                                                        </Grid2>
                                                                        <Grid2 children size={12}>
                                                                            <Field
                                                                                name={`milestones[${mIndex}].sprints[${sIndex}].description`}
                                                                                component={TextFormField}
                                                                                label="Description"
                                                                                multiline
                                                                                row={3}
                                                                            />
                                                                        </Grid2>
                                                                        <Grid2 children size={12}>
                                                                            <Field
                                                                                name={`milestones[${mIndex}].sprints[${sIndex}].learningOutcome`}
                                                                                component={TextFormField}
                                                                                label="Learning Outcome"
                                                                                multiline
                                                                                row={3}
                                                                            />
                                                                        </Grid2>
                                                                        <Grid2 children size={12}>
                                                                            <Field
                                                                                name={`milestones[${mIndex}].sprints[${sIndex}].prize`}
                                                                                component={TextFormField}
                                                                                label="Prize"
                                                                            />
                                                                        </Grid2>
                                                                        <Grid2 children size={12}>
                                                                            <Field
                                                                                name={`milestones[${mIndex}].sprints[${sIndex}].reductionPrize`}
                                                                                component={TextFormField}
                                                                                label="Reduction Prize"
                                                                            />
                                                                        </Grid2>
                                                                        <Grid2 children size={12}>
                                                                            <Field
                                                                                name={`milestones[${mIndex}].sprints[${sIndex}].numberOfSections`}
                                                                                component={TextFormField}
                                                                                label="Number Of Sections"
                                                                            />
                                                                        </Grid2>
                                                                    </Grid2>
                                                                </SprintWrapper>
                                                            ))}
                                                            <CustomDivider />
                                                            <Button
                                                                startIcon={<AddIcon />}
                                                                onClick={() =>
                                                                    pushSprint({
                                                                        sprintName: '',
                                                                        description: '',
                                                                        learningOutcome: '',
                                                                        prize: '',
                                                                        reductionPrize: '',
                                                                        numberOfSections: '',
                                                                    })
                                                                }
                                                                variant="outlined"
                                                                fullWidth
                                                            >
                                                                Add Sprint
                                                            </Button>
                                                        </>
                                                    )}
                                                </FieldArray>



                                            </MilestonesWrapper>
                                        </>

                                    ))}
                                    <Button
                                        startIcon={<AddIcon />}
                                        onClick={() =>
                                            pushMilestone({
                                                milestoneName: '',
                                                milestoneDescription: '',
                                                learningOutcome: '',
                                                prize: '',
                                                reductionPrize: '',
                                                subject: '',
                                                sprints: [
                                                    // {
                                                    //     sprintName: '',
                                                    //     description: '',
                                                    //     learningOutcome: '',
                                                    //     prize: '',
                                                    //     reductionPrize: '',
                                                    //     numberOfSections: '',
                                                    // },
                                                ],
                                            })
                                        }
                                        variant="contained"
                                        fullWidth
                                    // sx={{ mt: 2 }}
                                    >
                                        Add Milestone
                                    </Button>
                                </>


                            )}

                        </FieldArray >





                        {/* <MilestonesWrapper headerText={"Milestone 1"} onDelete={() => { }}>
                            <Grid2 container spacing={Grid_Gap_LG} >

                                <Grid2 children size={12}>
                                    <Field
                                        name="Milestone_Name"
                                        component={TextFormField}
                                        label="Milestone Name"
                                        isRequired={true}
                                    />
                                </Grid2>
                                <Grid2 children size={12}>
                                    <Field
                                        name="Milestone_Description"
                                        component={TextFormField}
                                        label="Milestone Description"
                                        isRequired={true}
                                        multiline
                                        row={3}
                                    />
                                </Grid2>
                                <Grid2 children size={12}>
                                    <Field
                                        name="Learning_Outcome"
                                        component={TextFormField}
                                        label="Learning Outcome"
                                        isRequired={true}
                                        multiline
                                        row={3}
                                    />
                                </Grid2>
                                <Grid2 children size={12}>
                                    <Field
                                        name="Prize"
                                        component={TextFormField}
                                        label="Prize"
                                        isRequired={true}
                                    />
                                </Grid2>
                                <Grid2 children size={12}>
                                    <Field
                                        name="Reduction_Prize"
                                        component={TextFormField}
                                        label="Reduction Prize"
                                        isRequired={true}
                                    />
                                </Grid2>
                                <Grid2 children size={12}>
                                    <Field
                                        name="Subject"
                                        component={TextFormField}
                                        label="Subject"
                                        isRequired={true}
                                    />
                                </Grid2>






                            </Grid2>
                            <CustomDivider />
                            <SprintWrapper headerText={"Milestone 1"} onDelete={() => { }}>
                                <Grid2 container spacing={Grid_Gap_LG} >

                                    <Grid2 children size={12}>
                                        <Field
                                            name="Sprint Name"
                                            component={TextFormField}
                                            label="Milestone Name"
                                            isRequired={true}
                                        />
                                    </Grid2>
                                    <Grid2 children size={12}>
                                        <Field
                                            name="Description"
                                            component={TextFormField}
                                            label="Description"
                                            isRequired={true}
                                            multiline
                                            row={3}
                                        />
                                    </Grid2>
                                    <Grid2 children size={12}>
                                        <Field
                                            name="Learning_Outcome"
                                            component={TextFormField}
                                            label="Learning Outcome"
                                            isRequired={true}
                                            multiline
                                            row={3}
                                        />
                                    </Grid2>
                                    <Grid2 children size={12}>
                                        <Field
                                            name="Prize"
                                            component={TextFormField}
                                            label="Prize"
                                            isRequired={true}
                                        />
                                    </Grid2>
                                    <Grid2 children size={12}>
                                        <Field
                                            name="Reduction_Prize"
                                            component={TextFormField}
                                            label="Reduction Prize"
                                            isRequired={true}
                                        />
                                    </Grid2>
                                    <Grid2 children size={12}>
                                        <Field
                                            name="Number_Of_Sections"
                                            component={TextFormField}
                                            label="Number Of Sections*"
                                            isRequired={true}
                                        />
                                    </Grid2>






                                </Grid2>
                            </SprintWrapper>

                            <Grid2 container size={12}>
                                <Button
                                    startIcon={<AddIcon />}
                                    fullWidth
                                    onClick={() => { }}
                                    variant='outlined'
                                >
                                    Add Sprints
                                </Button>
                            </Grid2>



                        </MilestonesWrapper>

   <CustomDivider />
                        <Grid2 container size={12}>
                            <Button
                                startIcon={<AddIcon />}
                                fullWidth
                                onClick={() => { }}
                                variant='contained'
                            >
                                Add Milestone
                            </Button>
                        </Grid2> */}
                        <CustomDivider />
                        <Grid2 container spacing={Grid_Gap}>
                            <Grid2 size={Input_Width} />
                            <Grid2 size={Input_Width}>
                                <Button fullWidth variant="outlined" onClick={resetForm} >Cancel</Button>
                            </Grid2>
                            <Grid2 size={Input_Width}>
                                <Button fullWidth variant="contained" type="submit">Submit </Button>
                            </Grid2>
                        </Grid2>
                    </Form>
                )}
            </Formik>
        </>
    )
}

export default MilestoneCourses
